import React from 'react';
import { Container, Col, Row } from '../../components/grid';
import {
  Paragraph, Heading1, Heading2,
} from '../../components/typography';
import { ItemTraverser } from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';
import RowProductView from '../../components/grid/RowProductView';

export default () => (
  <SidemenuLayout menuPicker="Sodavand" activeSidemenu="TuborgSquash">
    <Container white mb>
      <Row>
        <Col xs={12}>
          <Heading1>Tuborg Squash</Heading1>
          <Heading2>En ægte klassiker</Heading2>
          <Paragraph>
            Tuborg Squash er som Danmarks ældste sodavand (1936) blevet et charmerende folkeeje, der spreder glæde på tværs af alder og køn.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser category="tuborgSquash" display={ProductView1} />
      </RowProductView>
    </Container>
  </SidemenuLayout>
);
